import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "src/app/core/config.service";
import { CicdFactorisationsData} from "./cicd-factorisations.model";
import { map } from "rxjs";
import { CicdRepositoryTypeEnum } from "src/app/shared/enum/cicd-repository-type.enum";
import { CicdRepositories } from "src/app/store/cicd/repository/gitlab/cicd-repositories.model";

@Injectable({
    providedIn: 'root'
})
export class CicdFactorisationsService {

    constructor(private httpClient: HttpClient, private configService: ConfigService){

    }

    loadCicdFactorisationsData(){
        return this.httpClient.get<CicdFactorisationsData>(`${this.configService.config.apiUrl}/cicd/factorisations`)
        .pipe(
            map((response=>{
                const data = []
                const repositoryEnumKeys = Object.keys(CicdRepositoryTypeEnum);
                for(let type in response){
                    const repositories = response[type as keyof CicdRepositories]
                    if(repositoryEnumKeys.includes(type)){
                        data.push(...repositories.checked.map((value) => {return {...value, type: type}}))
                        data.push(...repositories.unchecked.map((value) => {return {...value, type: type}}))
                        data.push(...repositories.ignored.map((value) => {return {...value, type: type}}))
                    }
                }
                return data
            }))
        )
    }
}
